/**
 * /account-suspended — landing page for users whose account has been
 * suspended by a system admin.
 * Reached via error-handler pivot when BE returns 403 account_suspended.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { Ban } from "lucide-react";
import { LandingShell } from "@/features/system-admin/components/landing-shell";
import Button from "@/components/ui/button/Button";
import { useAuthActions } from "@/stores";

export const Route = createFileRoute("/account-suspended")({
  component: AccountSuspendedPage,
});

function AccountSuspendedPage() {
  const t = useTranslations("system-admin.common");
  const navigate = useNavigate();
  const { logout } = useAuthActions();

  const handleLogout = async () => {
    await logout();
    navigate({ to: "/signin" });
  };

  return (
    <LandingShell
      icon={
        <div className="flex size-16 items-center justify-center rounded-2xl bg-[var(--destructive-bg)] text-[var(--destructive)]">
          <Ban className="size-8" aria-hidden />
        </div>
      }
      title={t("landing.suspended.title")}
      description={t("landing.suspended.description")}
    >
      <Button variant="outline" onClick={handleLogout} className="w-full">
        {t("landing.actions.logout")}
      </Button>
    </LandingShell>
  );
}
